export const WRITERS_POSTS_PER_PAGE = 12;
